import { render, staticRenderFns } from "./OfferStatisticChart.vue?vue&type=template&id=bcaa620e&"
import script from "./OfferStatisticChart.vue?vue&type=script&lang=ts&"
export * from "./OfferStatisticChart.vue?vue&type=script&lang=ts&"
import style0 from "./OfferStatisticChart.vue?vue&type=style&index=0&id=bcaa620e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports